import styled from 'styled-components';
const ListItemContainer = styled.div.withConfig({ displayName: "brc-sc-ListItemContainer", componentId: "brc-sc-x744et" }) `
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex: 1 1 100%;
  width: 100%;
`;
ListItemContainer.displayName = 'ListItemContainer';
export const IconListContainer = ListItemContainer;
//# sourceMappingURL=icon-list-container.js.map